import React, { useState, useEffect } from "react";
import { Link } from "@quintype/components";
import { object, bool, string } from "prop-types";

import { getExcerpt } from "../../utils/utils";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import StoryMetaData from "../../molecules/StoryMetaData";

import "./relatedStory.m.css";

const RelatedStory = ({ story, isMobile, lang, storyClass }) => {
  const [imageType, setImageType] = useState("image3x2");
  const excerpt = getExcerpt(story);

  useEffect(() => {
    if (global.deviceWidth < 876) {
      setImageType("image1x1");
    }
  }, []);

  return (
    <div styleName="related-story-container" key={story.id} data-testid="related-storys">
      <div>
        <Link href={story.url} target="_blank" rel="noopener noreferrer">
          <Headline
            text={story.headline}
            headerLevel={3}
            headlineType={15}
            className={`story-headline ${lang === "en" ? "story-headline-en" : ""}`}
          />
        </Link>
      </div>
      <div styleName={storyClass} className="related-story">
        {!isMobile && (
          <div className="story-data">
            <Link href={story.url} target="_blank" rel="noopener noreferrer">
              <Headline
                text={excerpt}
                headerLevel={3}
                headlineType={6}
                className={`excerpt ${lang === "en" ? "en-excerpt" : ""}`}
              />
            </Link>
            <StoryMetaData story={story} isAuthor={false} showComments={false} />
          </div>
        )}
        <div>
          <Link href={story.url} target="_blank" rel="noopener noreferrer">
            <CardImage
              aspectRatio={[3, 2]}
              story={story}
              imageType={imageType}
              showAlternateImage={true}
              widths={[200]}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

RelatedStory.propTypes = {
  story: object.isRequired,
  isMobile: bool,
  lang: string,
  storyClass: string,
};

export default RelatedStory;
